import { Skeleton } from 'antd';
import * as Styled from './styles';

export const UserPanelTerminalViewSkeleton = () => {
  return (
    <Styled.UserPanelTerminalViewWrapper>
      <Skeleton.Button
        active
        style={{
          height: 64,
          width: 120,
          minWidth: 80,
          borderRadius: 16,
          margin: 0
        }}
      />
    </Styled.UserPanelTerminalViewWrapper>
  );
};
